/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * TAF Delivery API
 * OpenAPI spec version: 1.0
 */

export type LoginPageContentResponseModelContentType = typeof LoginPageContentResponseModelContentType[keyof typeof LoginPageContentResponseModelContentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LoginPageContentResponseModelContentType = {
  loginPage: 'loginPage',
} as const;
